import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useOrders = () => {
  const urlStr = `${getApiUrl()}/mega/order`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};

export const useOrder = (id) => {
  const urlStr = `${getApiUrl()}/mega/order/${id}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};

export const useOrderObject = (orderId) => {
  const orders = useOrders();
  const order = orders.data.content[orderId];
  return order;
};
